// extracted by mini-css-extract-plugin
export default {"GameWrapper":"GameWrapperStyles_GameWrapper__whKP+","gameOverMsg":"GameWrapperStyles_gameOverMsg__cTszk","fade-in-gameover-msg":"GameWrapperStyles_fade-in-gameover-msg__QNknF"};